import React from "react";
import {NavLink, useParams, useNavigate} from "react-router-dom";
import * as Utils from "../../inc/Utils";
import ResearcherSidebar from "./ResearcherSidebar";
import {Config} from "../../Config";
import toast, {Toaster} from "react-hot-toast";
import {confirmAlert} from "react-confirm-alert";
import moment from "moment-timezone";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

export default function ResearcherIntellectualCreate(prop) {

    let member = prop.member;

    let btnTextDefault = 'บันทึกข้อมูล';
    let btnTextLoading = 'กำลังบันทึก..';
    let [isLoading, setLoading] = React.useState(false);
    const navigate = useNavigate();

    let refTitle = React.useRef();
    let refTitle_en = React.useRef();
    let refIssueNo = React.useRef();
    let refRegisterNo = React.useRef();
    let refUrl = React.useRef();
    let refOrderId = React.useRef();
    let [statusChecked, setStatusChecked] = React.useState(true);

    let [researcher, setResearcher] = React.useState(null);
    React.useEffect(() => {
        (async function() {
            try {
                const resResearcher = await Utils.getResearcherMember(member);
                setResearcher(resResearcher);

                refOrderId.current.value = 9999;

            } catch (e) {
                toast.error(e.message);
            }
        })();
    }, []);

    const onCreate = () => {
        let title = refTitle.current.value;
        let title_en = refTitle_en.current.value;
        let issueNo = refIssueNo.current.value;
        let registerNo = refRegisterNo.current.value;
        let url = refUrl.current.value;
        let orderId = refOrderId.current.value;

        if(!title) {
            toast.error(prop.lang === 'en' ? 'Please input title':'กรุณาระบุ ชื่อสิ่งประดิษฐ์');
            refTitle.current.focus();
        }
        else if(!issueNo) {
            toast.error(prop.lang === 'en' ? 'Please input issue number':'กรุณาระบุ เลขที่คำขอ');
            refIssueNo.current.focus();
        }
        else if(!registerNo) {
            toast.error(prop.lang === 'en' ? 'Please input register number':'กรุณาระบุ เลขที่จดทะเบียน');
            refRegisterNo.current.focus();
        }
        else if(!url) {
            toast.error(prop.lang === 'en' ? 'Please input url':'กรุณาระบุ Link URL');
            refUrl.current.focus();
        }
        else {
            confirmAlert({
                title: prop.lang === 'en' ? 'Alert':'แจ้งเตือน',
                message: prop.lang === 'en' ? 'Want to save information ?':'ต้องการบันทึกข้อมูล ?',
                buttons: [
                    {
                        label: prop.lang === 'en' ? 'OK':'ตกลง',
                        onClick: () => {
                            setLoading(true);

                            let statusChecked = document.getElementsByName('statusChecked');

                            const body = {
                                researcherId: researcher.id,
                                title: title,
                                title_en: title_en,
                                issueNo: issueNo,
                                registerNo: registerNo,
                                url: url,
                                status: statusChecked[0].checked ? 1:0,
                                orderId: orderId,
                                createdBy: -1,
                                updatedBy: -1,
                                createdAt: moment().tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss'),
                                updatedAt: moment().tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss')
                            };
                            fetch(Config.apiUrl +'/researcherIntellectual/createMember', {
                                method: 'POST',
                                body: JSON.stringify(body),
                                headers: {
                                    'Content-Type':'application/json',
                                    'x-access-token': member.accessToken
                                }
                            }).then(response => {
                                setLoading(false);
                                if(response.ok) {
                                    return response.json();
                                }
                                else {
                                    return response.json().then(err => Promise.reject(err));
                                }
                            }).then(result => {
                                if(result) {
                                    toast.success(prop.lang === 'en' ? 'Save successfully':'บันทึกข้อมูลเรียบร้อย');
                                    setTimeout(function () {
                                        navigate((prop.lang === 'en' ? '/en':'') + '/profile/researcher/intellectual', {replace: true});
                                    }, 1500);
                                }
                            }).catch(err => {
                                toast.error(err.message);
                            })
                        }
                    },
                    {
                        label: prop.lang === 'en' ? 'Cancel':'ยกเลิก',
                        onClick: () => {}
                    }
                ]
            });
        }
    };

    return (
        <>
            <div className="section">
                <div className="container has-sidebar">
                    <div className="sidebar">
                        <ResearcherSidebar active="intellectual" lang={prop.lang} />
                    </div>
                    <div className="content">
                        <div className="card-infos has-shadow-black" data-aos="fade-in">

                            <div className="card-body p-0 px-xxl-3">
                                <h4 className="title-line-left mt-2 mb-3">{prop.lang === 'en' ? 'Researcher':'ข้อมูลนักวิจัย'}</h4>
                            </div>
                            <div className="d-flex justify-content-between gap-3">
                                <h6>{prop.lang === 'en' ? <>Certificate &rarr; Create New</>:<>ทรัพย์สินทางปัญญา &rarr; เพิ่มข้อมูล</>}</h6>
                            </div>

                            <form className="row g-3 mt-2">
                                <div className="col-12">
                                    <label htmlFor="title" className="form-label">{prop.lang === 'en' ? 'Title':'ชื่อสิ่งประดิษฐ์'} <span className="text-danger">*</span></label>
                                    <div className="input-group">
                                        <div className="input-group-text w100">Thai</div>
                                        <input type="text" className="form-control" id="title" ref={refTitle} maxLength={250} />
                                    </div>
                                    <div className="input-group mt-2">
                                        <div className="input-group-text w100">English</div>
                                        <input type="text" className="form-control" id="title_en" ref={refTitle_en} maxLength={250} />
                                    </div>
                                </div>

                                <div className="col-12">
                                    <label htmlFor="issueNo" className="form-label">{prop.lang === 'en' ? 'Issue Number':'เลขที่คำขอ'} <span className="text-danger">*</span></label>
                                    <input type="text" className="form-control" id="issueNo" ref={refIssueNo} maxLength={250} />
                                </div>

                                <div className="col-12">
                                    <label htmlFor="issueDate" className="form-label">{prop.lang === 'en' ? 'Register Number':'เลขที่จดทะเบียน'} <span className="text-danger">*</span></label>
                                    <input type="text" className="form-control" id="issueDate" ref={refRegisterNo} maxLength={250} />
                                </div>

                                <div className="col-12">
                                    <label htmlFor="url" className="form-label">Link URL <span className="text-danger">*</span></label>
                                    <textarea className="form-control" id="url" ref={refUrl} maxLength={4000} rows={5}></textarea>
                                </div>

                                <div className="col-12">
                                    <label htmlFor="orderId" className="form-label">{prop.lang === 'en' ? 'Order No':'ลำดับ'}</label>
                                    <div className="input-group">
                                        <input type="number" className="form-control" id="orderId" ref={refOrderId} min={1} max={9999} />
                                    </div>
                                </div>

                                <div className="col-12">
                                    <label htmlFor="statusx" className="form-label"></label>
                                    <div className="form-check">
                                        <input className="form-check-input" type="checkbox" name="statusChecked" id="status" checked={statusChecked} onChange={e => {setStatusChecked(e.target.checked)}} />
                                        <label className="form-check-label" htmlFor="status">{prop.lang === 'en' ? 'Publish':'เปิดใช้งาน'}</label>
                                    </div>
                                </div>
                            </form>

                            <div className="buttons gap-15 pb-0 my-sm-4">
                                <button className="btn btn-primary w-130" type="button" onClick={onCreate} disabled={isLoading}>
                                    <span className={isLoading ? 'spinner-grow spinner-grow-sm' : 'd-none'}></span> {prop.lang === 'en' ? 'Create':'บันทึก'}
                                </button>
                                <NavLink className="btn btn-gray w-130" to={(prop.lang === 'en' ? '/en':'') + '/profile/researcher/intellectual'}>{prop.lang === 'en' ? 'Back':'กลับไป'}</NavLink>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
            <Toaster position="top-right" />
        </>
    );
}